import React, {useEffect} from 'react'
import {fetchAllProducts, productSelector} from '../../../api/productSlice'
import {  useDispatch, useSelector } from 'react-redux';
import Loader from '../../../shared/loader'
import Products from './product'
import { Fade } from 'react-reveal';
import { Link } from 'react-router-dom';
import {MdCardGiftcard} from 'react-icons/md'
// import ViewMore from './viewMore'
// import Footer from '../../../global/footer'
export default function Index() {
    const dispatch = useDispatch()

    // const {scoupons, loading} = useSelector(scouponsSelector)
    const { products, loading } = useSelector(productSelector)


    useEffect(()=>{
        // dispatch(fetchScoupons())
        dispatch(fetchAllProducts())
        
    }, [dispatch])

    
   
    return (
        <div className='container md:px-0 px-8 md:py-12 py-4  mx-auto lg:w-3/5 block'style={{minHeight:"70vh"}}>
                <h2 className='md:text-[24px] text-[18px]  '>Products & Gifts</h2>
            <hr/>
            <div className='flex flex-wrap '>
            {products.map((item, i) => {
        return (
            
          <div className="my-3 md:w-[255px] w-[310px]   mx-4 md:mx-3  border-white rounded-3xl  z-80 md:shadow-xl shadow-xl">
            <Fade duration={2000}>
              <Link to={`/products/${item._id}`}>
                <div >
                  {/* // cover={<img alt="example" style={{height:"250px"}} src={`https://sycamoredev.herokuapp.com/static/${item.image}`} />} */}

                  {item?.image ? (
                    <img
                      src={item?.image}
                      className="md:my-[24px] my-[4px] h-[140px]  object-cover w-full "
                      alt="imglogo"
                    />
                  ) : (
                    <span
                      className="md:my-[24px] my-[4px] md:h-[140px] h-[80px] object-cover w-full "
                    >
                      <MdCardGiftcard className="voucher text-center" />
                      &nbsp;
                    </span>
                  )}

                  {/* <hr/> */}

                  <h6
                    className="bg-[#9a4c9d] text-center rounded-b-3xl   text-white md:pt-1 pt-3 mb-0 text-[14px]  md:h-12 h-12 "
                  >
                    {item.name}
                  </h6>

                  {/* <PButton size="small"  type="primary" productId={item._id} total={item.price} user={curr_user} title={item.title}>shop</PButton>   */}
                </div>
              </Link>
            </Fade>
          </div>
          
        );
      })}
      </div>
      
      {/* <ViewMore />  */}
        
        </div>
    )
}
